/**
 * DSA-A-46 lead `source` for the BE Application payload and Amplitude (`inquiry_source` / `source_id`).
 * Both Amplitude fields use the same dictionary value.
 *
 * KM comparator uses `Comparator = 206`. RP keeps `ComparisonToolProperty = 43` for its comparator —
 * do not reuse 43 for KM.
 *
 * KM recommended-properties carousel uses `HomematchRecommended = 207` with
 * `ApplicationSourceSection.RecommendedPropertiesCarouselAskOffer = 213`.
 * Do not reuse `HomematchTinder = 301` (Tinder deck) for that CTA.
 *
 * KM investment-level inquiries use `InvestmentInquiry = 202` with no `property` in the payload — RP accepts
 * `offer` only for that source, and rejects 53.
 *
 * ATTENTION: remember to inform backend to add new value to database validation.
 */
export enum ApplicationSource {
    FavouritesPropertyInquiry = 38,
    Property = 200,
    InvestmentInquiry = 202,
    HomematchBasic = 203,
    Comparator = 206,
    HomematchRecommended = 207,
    HomematchLite = 300,
    HomematchTinder = 301
}
/**
 * DSA-A-46 lead `source` for the BE Application payload and Amplitude (`inquiry_source` / `source_id`).
 * Both Amplitude fields use the same dictionary value.
 *
 * KM comparator uses `Comparator = 206`. RP keeps `ComparisonToolProperty = 43` for its comparator —
 * do not reuse 43 for KM.
 *
 * KM recommended-properties carousel uses `HomematchRecommended = 207` with
 * `ApplicationSourceSection.RecommendedPropertiesCarouselAskOffer = 213`.
 * Do not reuse `HomematchTinder = 301` (Tinder deck) for that CTA.
 *
 * KM investment-level inquiries use `InvestmentInquiry = 202` with no `property` in the payload — RP accepts
 * `offer` only for that source, and rejects 53.
 *
 * ATTENTION: remember to inform backend to add new value to database validation.
 */
export enum ApplicationSource {
    FavouritesPropertyInquiry = 38,
    Property = 200,
    InvestmentInquiry = 202,
    HomematchBasic = 203,
    Comparator = 206,
    HomematchRecommended = 207,
    HomematchLite = 300,
    HomematchTinder = 301
}
